export default {
	activities: {
		header: 'Aktywność',
		show: 'Zobacz wątek',
	},
	visibilities: {
		all: 'Wszyscy',
		team: 'Zespół',
		group: 'Grupa',
		private: 'Prywatny'
	},
	addNewPost: {
		header: 'Opublikuj nowy wpis',
		startTyping: 'Rozpocznij pisanie',
		buttons: {
			addPhoto: 'Zdjęcie',
			addVideo: 'Wideo',
			addPoll: 'Ankieta',
			addProblem: 'Problem',
			addAnnouncement: 'Ogłoszenie',
		},
		dialog: {
			post: {
				header: 'Dodaj nowy wpis',
				editHeader: 'Edytuj wpis',
				publishAs: 'Publikujesz jako',
				tooltips: {
					post: 'Zwykły post',
					image: 'Dodaj zdjęcie do postu',
					video: 'Dodaj film do postu',
					poll: 'Dodaj ankietę do postu',
					problem: 'Dodaj problem',
					announcement: 'Dodaj ogłoszenie',
					attachment: 'Dodaj załącznik',
					praise: 'Dodaj pochwałę'
				}
			},
			photo: {
				header: 'Dodaj zdjęcie',
				info: 'Maksymalny rozmiar pliku wynosi 5MB. Dozwolone formaty: jpg, png, gif',
				get: 'Wybierz zdjęcie z dysku',
				getAnother: 'Wybierz inne zdjęcie',
				drag: 'albo przeciągnij je tutaj'
			},
			video: {
				header: 'Dodaj film',
				get: 'Wybierz film z dysku',
				drag: 'albo przeciągnij go tutaj',
				size: 'Maksymalny rozmiar pliku wynosi',
			},
			poll: {
				header: 'Utwórz ankietę',
				addOption: 'Dodaj kolejną opcję',
				time: 'Określ czas trwania ankiety',
				question: 'Pytanie',
				allow: 'Pozwól na dodawanie własnych odpowiedzi',
				summary: 'Przejdź do podsumowania',

			},
			announcement: {
				header: 'Dodaj nowe ogłoszenie',
				pinned: 'Wyświetlaj jako przypięty wpis'
			}
		}
	},
	notes: {
		header: 'Notes',
		show: 'Pokaż więcej'
	},
	post: {
		groupPost: 'Wpis z grupy',
		userAddedPost: 'dodał(a) wpis',
		goTo: 'Zobacz post',
		notFound: 'Nie znaleziono postu',
		deleted: 'Post usunięty przez autora',
		deletePostConfirm: 'Na pewno chcesz usunąć ten post?',
		edited: 'Edytowano',
		pinned: 'Przypięty post',
		publish: 'Napisz',
		update: 'Zaktualizuj',
		commentFilters: {
			all: 'Wszystkie komentarze',
			new: 'Najnowsze komentarze',
			popular: 'Najpopularniejsze komentarze'
		},
		actions: {
			delete: 'Usuń post',
			edit: 'Edytuj post',
			commentsOff: 'Wyłącz komentowanie',
			commentsOn: 'Włącz komentowanie',
			notificationsOff: 'Wyłącz powiadomienia',
			reportAbuse: 'Zgłoś nadużycie'
		},
		buttons: {
			react: 'Poleć',
			reaction: 'Zareaguj',
			reacted: {
				like: 'Dobra robota',
				love: 'Super',
				happy: 'Podoba mi się',
				applause: 'Gratulacje'
			},
			comment: 'Skomentuj',
			share: 'Udostępnij',
			save: 'Zapisz post',
			idea: 'Dodaj pomysł',
			ideaShort: 'Pomysły',
			solution: 'Zobacz rozwiązanie',
			solutionShort: 'Rozwiązanie',
		},
		comment: {
			startComment: 'Napisz komentarz...',
			actions: {
				edit: 'Edytuj komentarz',
				remove: 'Usuń komentarz'
			},
			save: 'Zapisz na później',
			idea: 'Dodaj pomysł',
			solution: 'Zobacz rozwiązanie',
			loadAnswers: 'Wyświetl więcej (%{count} wszystkich)'
		},
		reaction: {
			persons: 'i 12 innych osób'
		},
		readMore: 'Czytaj więcej'
	},
	posts: {
		noPosts: 'Brak postów do wyświetlenia'
	},
	poll: {
		addPoll: 'Dodaj ankietę',
		editPoll: 'Edytuj ankietę',
		userAddedPoll: 'dodał(a) ankietę',
		addCustomAnswer: 'Dodaj kolejną opcję',
		revertVote: 'Cofnij swój głos',
	},
	problem: {
		addProblem: 'Dodaj problem',
		editProblem: 'Edytuj problem',
		startAddIdea: 'Opisz swój pomysł...',
		userAddedProblem: 'dodał(a) problem',
		addIdea: 'Dodaj pomysł',
		status: {
			new: 'Zgłoszono',
			inProgress: 'Wybrano rozwiązanie',
			analyzed: 'W trakcie analizy',
			resolved: 'Rozwiązano'
		},
		changeTo: 'Zmień na:',
		changeStatus: 'Zmień status',
		cannotChange: 'Nie możesz zmienić statusu',
		actions: {
			editIdea: 'Edytuj pomysł',
			deleteIdea: 'Usuń pomysł',
			setAsSolution: 'Wybierz jako rozwiązanie',
			isSolution: 'Wybrano jako rozwiązanie',
			addDescription: 'Dodaj opis do rozwiązania'
		},
		noSolutionDescription: 'Użytkownik nie dodał opisu do rozwiązania'
	},
	attachments: {
		download: 'Pobierz załącznik'
	},
	announcement: {
		addAnnouncement: 'Dodaj ogłoszenie',
		editAnnouncement: 'Edytuj ogłoszenie',
		userAddedAnnouncement: 'dodał(a) ogłoszenie',
		announcement: 'Ogłoszenie',
		companyAnnouncement: "Ogłoszenie firmowe"
	},
	kudos: {
		addKudos: 'Dodaj pochwałę dla użytkownika',
		editKudos: 'Edytuj pochwałę',
		userAddedKudos: 'pochwalił(a) użytkownika',
		chooseUser: 'Wybierz odbiorcę',
		contentPlaceholder: 'Napisz coś miłego...',
		summary: 'Przejdź do podsumowania'
	},
	photo: {
		userAddedPhoto: 'dodał(a) zdjęcie'
	},
	video: {
		userAddedVideo: 'dodał(a) film'
	},
	toDoList: {},
	filters: {
		new: 'Sortuj od najnowszych',
		old: 'Sortuj od najstarszych',
		top: 'Sortuj po najpopularniejszych',
		activity: 'Sortuj po ostatniej aktywności',

	}
}
